/**
 * Casdoor OAuth 回调页面
 * Casdoor 认证完成后跳转至此，提取 ?code=xxx 并调用后端换取本地 JWT
 */
import React, { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';

const CasdoorCallback: React.FC = () => {
  const { casdoorLogin } = useAuth();
  const [status, setStatus] = useState<'loading' | 'error'>('loading');
  const [message, setMessage] = useState('正在完成登录...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const errorDesc = params.get('error_description') || params.get('error');

    if (errorDesc) {
      setStatus('error');
      setMessage(decodeURIComponent(errorDesc) || 'Casdoor 授权失败');
      return;
    }

    if (!code) {
      setStatus('error');
      setMessage('缺少授权码，请重新登录');
      return;
    }

    // 从 sessionStorage 中取回推荐码
    const refCode = sessionStorage.getItem('referral_ref');
    sessionStorage.removeItem('referral_ref');

    casdoorLogin(code, refCode).then((result) => {
      if (result.success) {
        // 登录成功，通过 reload 让 App.tsx 检测到 token 后正常渲染
        window.location.href = '/';
      } else {
        setStatus('error');
        setMessage(result.message || 'Casdoor 登录失败');
      }
    }).catch(() => {
      setStatus('error');
      setMessage('网络错误，登录失败');
    });
  }, [casdoorLogin]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <div className="text-center">
        {status === 'loading' ? (
          <>
            <div className="w-10 h-10 border-3 border-green-600 border-t-transparent rounded-full animate-spin mx-auto" />
            <p className="mt-4 text-sm text-gray-600">{message}</p>
          </>
        ) : (
          <>
            <div className="w-10 h-10 rounded-full bg-red-100 text-red-600 flex items-center justify-center mx-auto">
              <span className="text-lg font-bold">!</span>
            </div>
            <p className="mt-4 text-sm text-red-600">{message}</p>
            <button
              onClick={() => { window.location.href = '/'; }}
              className="mt-4 inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 transition-colors"
            >
              返回登录
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CasdoorCallback;
